// GPS track breadcrumb layer family.
//
// Extracted from addOverlays.ts as HI-1 batch 5 round 2 (audit 2026-05-22).
// Pure mechanical move — every source, layer, paint expression,
// layout property, and minzoom/maxzoom is byte-identical to its
// pre-extraction form. Source-id idempotency guard preserved.

import type { Map as MlMap } from 'maplibre-gl';
import { EMPTY_FC } from '../MapView';
import { registerLayerFamily } from '../layerVisibilityRegistry';
import { useLayerVisibilityStore } from '../../stores/layerVisibilityStore';

/**
 * Mount the track source + its layers. Idempotent on the source.
 */
export function addTrackLayers(map: MlMap): void {
    if (!map.getSource('track')) {
      map.addSource('track', { type: 'geojson', data: EMPTY_FC });
      map.addLayer({
        id: 'track-line',
        type: 'line',
        source: 'track',
        paint: {
          'line-color': '#39ff14',
          'line-width': 2.5,
        },
      });
    }
}

registerLayerFamily({
  id: 'track',
  label: 'GPS track breadcrumb',
  sourceId: 'track',
  layerIds: ['track-line'],
  mount: (map) => addTrackLayers(map),
  // NOTE: TrackController owns visibility via useLayerVisibility().
  // We add applyState here ONLY for basemap-rebuild restoration
  // (so the layer doesn't silently disappear after chart switch).
  applyState: (map) => {
    if (!map.getLayer('track-line')) return;
    const show = useLayerVisibilityStore.getState().layers.breadcrumbs;
    map.setLayoutProperty('track-line', 'visibility', show ? 'visible' : 'none');
  },
  // No visibilitySelector: TrackController manages visibility reactively.
});
